import { createSelector } from "@ngrx/store";

import { AppState } from "../store";
import { RequestState } from ".";

const feature = (state: AppState) => state.request;

export const requestSelector = createSelector(
  feature,
  (state: RequestState) => state.requests
);

export const totalsRequestSelector = createSelector(
  feature,
  (state: RequestState) => ({
    totalRequests: state.totalRequests,
    completedRequests: state.completedRequests,
    failedRequests: state.failedRequests,
  })
);
